import { jsx as _jsx } from "react/jsx-runtime";
const ChevronDown = ({ className }) => {
    return (_jsx("svg", { width: "8", height: "6", viewBox: "0 0 8 6", fill: "none", className: className, xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M4 6L0.535899 -6.52533e-07L7.4641 -4.68497e-08L4 6Z", fill: "black", fillOpacity: "0.3" }) }));
};
export default ChevronDown;
//# sourceMappingURL=chevronDown.js.map